/**
 * Costura REST do sino in-app — os dois únicos verbos que o chat usa.
 *
 * O motor expõe cinco (`GET /`, `GET /:id`, `PATCH /:id`, `POST /`, `DELETE /:id`),
 * mas criar e apagar são admin e não pertencem ao sino do operador. Este módulo
 * existe para que o store não carregue caminho de URL nem forma de resposta:
 * se o contrato do motor mudar, muda aqui e em nenhum outro lugar do chat.
 */
import { api } from '../api'
import type { ListAlertsResponse, UpdateAlertResponse } from '../../types/alerts'

/** Teto da lista. O `unreadCount` vem do servidor e NÃO depende deste limite. */
export const ALERTS_LIST_LIMIT = 30

/** Lista do sino deste usuário + contagem de não lidos. */
export function fetchAlertList(limit = ALERTS_LIST_LIMIT): Promise<ListAlertsResponse> {
  return api.get<ListAlertsResponse>(`/api/v1/alerts?limit=${limit}`)
}

/** Marca (ou desmarca) como lido o alerta deste usuário. */
export function patchAlertRead(id: string, read: boolean): Promise<UpdateAlertResponse> {
  return api.patch<UpdateAlertResponse>(`/api/v1/alerts/${id}`, { read })
}
